/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyRenminbi = createReactComponent("outline", "currency-renminbi", "IconCurrencyRenminbi", [["path", { "d": "M15 9v8a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M19 9h-14", "key": "svg-1" }], ["path", { "d": "M19 5h-14", "key": "svg-2" }], ["path", { "d": "M9 9v4c0 2.5 -.667 4 -2 6", "key": "svg-3" }]]);

export { IconCurrencyRenminbi as default };
//# sourceMappingURL=IconCurrencyRenminbi.mjs.map
